<h3>Manage Sponsors</h3>
<br>
<div>Click on the sponsor's name to check accounts created by them</div>

<!-- <div *ngFor="let sponsor of sponsors"> -->
<table mat-table [dataSource]="dataSource2" matsort>

  <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

  <!-- Name Column -->
  <ng-container matColumnDef="firstName">
    <th mat-header-cell *matHeaderCellDef> Sponsor name </th>
    <td mat-cell *matCellDef="let sponsor"> <a [routerLink]="['/admin', sponsor.sponsorId, 'guests']">{{sponsor.firstName}} {{sponsor.lastName}}</a> </td>
  </ng-container>

  <!-- Weight Column -->
  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef> Email </th>
    <td mat-cell *matCellDef="let sponsor"> {{sponsor.email}} </td>
  </ng-container>

  <!-- Symbol Column -->
  <ng-container matColumnDef="iNumber">
    <th mat-header-cell *matHeaderCellDef> INumber </th>
    <td mat-cell *matCellDef="let sponsor"> {{sponsor.iNumber}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef='displayedColumns2'></tr>
  <tr mat-row *matRowDef='let row; columns: displayedColumns2;' class="sponsor-row"></tr>

</table>